import "./Benefits.scss";
import { VacancyBenefitsComponent_Plain } from "../../../types/components/page/VacancyBenefitsComponent.ts";
import { getStrapiMedia } from "../../../utils/utils.tsx";
// Импортируем Swiper и необходимые модули
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
// Импортируем стили Swiper
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const Benefits = ({ data }: { data: VacancyBenefitsComponent_Plain }) => {
  const totalBenefits = data.benefits.length;
  const formatNumber = (num: number) => {
    return num < 10 ? `0${num}` : num.toString();
  };

  return (
    <>
      <section className="benefits">
        <div className="benefits__img">
          {data.bg1 ? (
            <img src={getStrapiMedia(data.bg1.url)} alt="" />
          ) : (
            <img src="/img/bg-benefit.jpg" alt="" />
          )}
        </div>
        <div className="wrapper">
          <div className="block-title">{data.title}</div>
          <h2>{data.description}</h2>
          <div className="benefits__infografic">
            {data.bg2 ? (
              <img src={getStrapiMedia(data.bg2.url)} alt="" />
            ) : (
              <img src="/img/bg_benefit_info.svg" alt="" />
            )}
            <div className="benefits__infografic-logo">
              <img width="138" height="17" src="/img/logo_new_white.svg" />
            </div>
          </div>
        </div>
        <div className="benefits-swiper-container">
          <Swiper
            modules={[Navigation, Pagination]}
            spaceBetween={16}
            slidesPerView={1}
            navigation
            pagination={{
              clickable: true,
              type: "fraction",
            }}
            breakpoints={{
              640: {
                slidesPerView: 2,
                spaceBetween: 16,
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 16,
              },
            }}
            className="benefits-list"
          >
            {data.benefits.map((item, index) => (
              <SwiperSlide key={index} className="benefits-list__item">
                <div className="benefits-list__top">
                  <div className="benefits-list__name">{item.name}</div>
                  <p>{item.description}</p>
                </div>
                <div className="benefits-list__bottom">
                  <div className="benefits-list__num">
                    {formatNumber(index + 1)} / {totalBenefits}
                  </div>
                  <div className="benefits-list__icon">
                    {item.icon ? (
                      <img src={getStrapiMedia(item.icon.url)} />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>
    </>
  );
};

export default Benefits;
